import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'teacherReferral',
    label: 'Teacher Referral',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
